import dayjs from 'dayjs';
import { isInclusivelyBeforeDay } from 'react-dates';

export const datePickerControllerProps = {
  // stops selection of future dates
  isOutsideRange: (day) => !isInclusivelyBeforeDay(day, dayjs()),
  // stops scrolling calendar to future months
  maxDate: dayjs(),
};

export const datePickerProps = {
  fromPlaceholder: 'The beginning',
  toPlaceholder: 'today',
};

export const reelsSortingOptions = [
  { value: null, label: 'Most Recent' },
  { value: 'plays', label: 'Plays' },
  { value: 'interactions', label: 'Interactions' },
  { value: 'viewEngagement', label: 'VER (View Engagment Rate)' },
];

export const storiesSortingOptions = [
  { value: null, label: 'Most Recent' },
  { value: 'reach', label: 'Reach' },
  { value: 'impressions', label: 'Impressions' },
];

export const postSortingOptions = [
  { value: null, label: 'Most Recent' },
  { value: 'engagements', label: 'Engagements' },
  { value: 'reach', label: 'Reach' },
  { value: 'impressions', label: 'Impressions' },
  { value: 'postReachEngRate', label: 'RER (Reach Engagement Rate)' },
  { value: 'postFollowersEngRate', label: 'FER (Follower Engagement Rate)' },
];
